export const APP_LANGUAGES = [
    { value: "en", label: "English", flag: "🇺🇸" },
    { value: "es", label: "Español", flag: "🇪🇸" },
    { value: "pt", label: "Português", flag: "🇧🇷" },
];
